import './styles.css';
import { Breadcrumb } from 'antd';
import { BreadcrumbItemType, BreadcrumbSeparatorType } from 'antd/es/breadcrumb/Breadcrumb';
import { HomeOutlined } from '@ant-design/icons';
import { useCompany } from '../../../hooks/useCompany';

interface ICardHeaderProps {
    pageName: string,
    linkPageBefore?: string,
    pageBeforeName?: string,
    hasPageBefore: boolean,
    isToHome?: boolean,
}

const CardHeader = ({ pageName, hasPageBefore, linkPageBefore = "", pageBeforeName = "" }: ICardHeaderProps) => {
    const { company } = useCompany();

    const items: Partial<BreadcrumbItemType & BreadcrumbSeparatorType>[] = [
        {
            title: (
            <a href={`/${company.serviceId}/home`}>
                <HomeOutlined style={{ marginRight: 4 }} /> Homepage
            </a>
            ),
        }
    ];

    if (hasPageBefore && linkPageBefore != "" && pageBeforeName != "") {
        items.push(
            {
                title: <a href={linkPageBefore}>{pageBeforeName}</a>,
            },
            {
                title: pageName?.length > 30? `${pageName.slice(0,30)}...`: pageName,
            }
        );
    } else {
        items.push(
            {
                title: pageName?.length > 30? `${pageName.slice(0,30)}...`: pageName,
            }
        );
    }

    return (
        <div title={pageName} className='card-header d-flex align-items-center justify-content-start'>
            <Breadcrumb
                items={items}
            />
        </div>
    );
}

export default CardHeader;